/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import styled from "styled-components";

import { DEVICE } from "src/app/globalStyles";
import { PageScreenshotWrapper, StyledScreenshotImg } from "src/components/Shared/PageThumbnail/PageScreenshot";
import { StyledPageTitle } from "src/components/Shared/PageThumbnail/PageThumbnailTitle";
import { UnstyledLink } from "src/components/UI/Links";

interface Props {
  title: string;
  url: string;
  thumbnailUrl: string;
}

export const ViewOnlyPlateThumbnail = ({ title, url, thumbnailUrl }: Props) => {
  return (
    <ViewOnlyPlateThumbnailWrapper>
      <UnstyledLink href={url} target="_blank" rel="noopener noreferrer">
        <PageScreenshotWrapper>
          <StyledScreenshotImg
            isPublic
            draggable={false}
            src={thumbnailUrl}
            plateTitle={title}
            alt={title}
          ></StyledScreenshotImg>
        </PageScreenshotWrapper>
        <ViewOnlyStyledPageTitle $isPublic>{title}</ViewOnlyStyledPageTitle>
      </UnstyledLink>
    </ViewOnlyPlateThumbnailWrapper>
  );
};

const ViewOnlyPlateThumbnailWrapper = styled.div`
  /* TODO this should extend from previewwrpapper */
  display: flex;
  flex-direction: column;
  user-select: none;
  cursor: "default";
  :hover {
    text-decoration: "default";
  }

  width: 132px;
  max-width: 45%;
  @media (max-width: ${DEVICE.medium}) {
    width: unset;
  }
`;

const ViewOnlyStyledPageTitle = styled(StyledPageTitle)`
  line-height: 1.2;
`;

export const ExampleGallery = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 1rem;
  margin: 1rem 0;
  margin-bottom: 20px;
  width: 100%;
`;
